module.exports = __webpack_public_path__ + "static/logo-3a4ec5483a63aa69cfd8f6a44111c7fa.svg";